export const CAMERA = {
  position: [0, -0.15, 2.0],
  fov: 35,
};

export const LIGHTS = {
  ambient: { intensity: 0.42 },
  directional: [
    { position: [2.5, -1.5, 3], intensity: 0.55 },
    { position: [-2, 1, 2.5], intensity: 0.22 },
    { position: [0, 3, 1], intensity: 0.12 },
  ],
};

export const MATERIAL = {
  roughness: 0.62,
  metalness: 0.0,
};

export const ORBIT_CONTROLS = {
  enableRotate: false,
  enablePan: false,
  minDistance: 0.82,
  maxDistance: 5.0,
};

export const GROUP_POSITION = [0, -0.15, 0];

export const ROTATION_SPEED = 0.006;

export const MINI_VIEWER_SCALE = 0.9;
